export default {
  elevation1: {
    boxShadow: '0px 2px 4px rgba(23, 23, 23, 0.08)',
  },
  rounded: {
    borderRadius: 8,
  },
};
